import http from '../../http';

export function fetchSidebar () {
  return (dispatch) => dispatch({
    type: 'FETCH_SIDEBAR',
    payload: http().get('/navigation/items'),
  });
}
